import React, { ComponentType, Suspense, lazy } from 'react';

import Spinner from 'src/views/spinner/Spinner';

const CHUNK_RELOAD_KEY = 'jk-loom-chunk-reload';

function isChunkLoadError(error: unknown): boolean {
  if (error instanceof Error) {
    return error.name === 'ChunkLoadError' || error.message.includes('Loading chunk');
  }

  return false;
}

/** Lazy import that auto-reloads once when a stale webpack chunk fails (common after HMR). */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function lazyWithRetry(importer: () => Promise<{ default: ComponentType<any> }>) {
  return lazy(async () => {
    try {
      const module = await importer();
      sessionStorage.removeItem(CHUNK_RELOAD_KEY);

      return module;
    } catch (error) {
      const alreadyReloaded = sessionStorage.getItem(CHUNK_RELOAD_KEY) === '1';

      if (!alreadyReloaded && isChunkLoadError(error)) {
        sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
        window.location.reload();

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return { default: (() => null) as ComponentType<any> };
      }

      throw error;
    }
  });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Loadable = (Component: ComponentType<any>) => (props: any) =>
  (
    <Suspense fallback={<Spinner />}>
      <Component {...props} />
    </Suspense>
  );

export default Loadable;
